import {
  withGetFragmentTable,
  withInsertFragmentTable,
  withInsertTextTable,
  withNormalizeTable,
  withSelectionTable,
  withDeleteTable,
  withMarkTable,
} from '@udecode/plate-table';

import { withSetFragmentDataTable } from './withSetFragmentDataTable';
import { withNormalizeUnbalancedTables } from './withNormalizeUnbalancedTables';
import { withNormalizeTableNodeIds } from './withNormalizeTableNodeIds';
import { withNormalizeTable2 } from './withNormalizeTable2';
import { withSafeTable } from './withSafeTable';


export const withTable = (
  editor,
  plugin,
) => {
  let _editor = editor;
  _editor = withNormalizeTable2(editor);
  _editor = withNormalizeTable(editor);
  _editor = withDeleteTable(editor);
  _editor = withGetFragmentTable(editor, plugin);
  _editor = withInsertFragmentTable(editor, plugin);
  _editor = withInsertTextTable(editor, plugin);
  _editor = withSelectionTable(editor);
  _editor = withSetFragmentDataTable(editor);
  _editor = withMarkTable(editor);
  _editor = withNormalizeUnbalancedTables(editor);
  _editor = withNormalizeTableNodeIds(editor);
  _editor = withSafeTable(editor);

  return _editor;
};
